import { AddRequestStatus, IPhoneContact } from "./userType";

export interface SearchUserAddRequestResult {
  message?: string;
  addRequests: AddRequestType[];
}

export interface AddRequestType {
  _id?: string;
  member: Member;
  union?: string;
  status?: AddRequestStatus;
  created_At?: any;
  updated_At?: any;
}

export interface Member {
  _id?: string;
  phone: IPhoneContact;
  firstName: string;
  lastName: string;
  email: string;
}

export interface ViewAndSearchAddRequestSendOutQueryPayload {
  _id?: string;
  firstName: string;
  lastName: string;
  email: string;
  status: any;
}

export const EmptyViewAndSearchAddRequestSendOutQueryPayload = {
  // _id:"",
  firstName: "",
  lastName: "",
  email: "",
  status: "",
};
